import * as types from './mutation-types.js';
const mutations={
	[types.STORAGE_USERINFO](state,data){
		console.log(data)
		if(data == ''||data==null){
			state.userInfo = {};
			state.userId = null;
			state.token = null;
		}else{
			state.userInfo = data;
			state.userId = data.userId;
			state.token = data.token;
		}
	},
	[types.LOADING](state,data){
		state.Loading=data;
	},
	[types.RECORDED](state,data){
		state.selectedRecorded=data;
	},
	[types.VIDEOURL](state,data){
		state.videoUrl=data;
	},
	[types.WXSHARE](state,data){
		state.wxShare=data;
		console.log(data)
	},
	[types.RECORDING](state,data){
		state.recording=data;
		console.log(data)
	},
	[types.MEETING_ID](state,data){
		state.meeting_id=data;
		console.log(data)
	}
}
export default mutations;


// WEBPACK FOOTER //
// ./src/store/mutations.js